module.exports = "https://cdn.dove.it/_next/static/public/assets/come-funziona-doveit.970ba7afce1c6f5c1674c153657c0512.png";